<template>
  <div>
    <!-- Breadcrumb Section Begin -->
    <div class="breacrumb-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-text">
                      <router-link to="/"><i class="fa fa-home"></i> {{ $t('nav.home') }}</router-link>
                        <span>{{ $t('breadcrumb.contact') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Breadcrumb Section Begin -->
    <section class="contact-section spad" v-if="contato!=''">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="contact-title">
                        <h4>{{ $localeField(contato[0], 'itiNome') }}</h4>
                    </div>
                    <div class="contact-widget">
                        <div class="cw-item">
                            <div class="ci-icon">
                                <i class="ti-mobile"></i>
                            </div>
                            <div class="ci-text">
                                <span>{{ $t('contact.phone') }}</span>
                                <p>{{ contato[0].itiCampoExtra2 }}</p>
                            </div>
                        </div>
                        <div class="cw-item">
                            <div class="ci-icon">
                                <i class="ti-mobile"></i>
                            </div>
                            <div class="ci-text">
                                <span>{{ $t('contact.phone') }}</span>
                                <p>{{ contato[0].itiCampoExtra3 }}</p>
                            </div>
                        </div>
                        <div class="cw-item">
                            <div class="ci-icon">
                                <i class="ti-email"></i>
                            </div>
                            <div class="ci-text">
                                <span>{{ $t('contact.email') }}</span>
                                <p>{{ contato[0].itiCampoExtra4 }} </p>
                            </div>
                        </div>
                        <div class="cw-item">
                            <div class="ci-icon">
                                <i class="fa fa-whatsapp"></i>
                            </div>
                            <div class="ci-text">
                                <span>{{ $t('contact.whatsapp') }}</span>
                                <a :href="contato[0].itiCampoExtra6" target="_blank">
                                <p>{{ contato[0].itiCampoExtra5 }}</p>
                              </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 offset-lg-1">
                    <div class="contact-form">
                        <div class="leave-comment">
                            <h4>{{ $localeField(contato[0], 'itiReferencia') }}</h4>
                            <form action="#" class="comment-form">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <input type="text" v-model="Nome" :placeholder="$t('contact.yourName')">
                                    </div>
                                    <div class="col-lg-6">
                                        <input type="text" v-model="Email"  :placeholder="$t('contact.yourEmail')">
                                    </div>
                                    <div class="col-lg-6">
                                        <input type="text" v-model="Telefone"  :placeholder="$t('contact.yourWhatsapp')">
                                    </div>
                                    <div class="col-lg-12">
                                        <textarea v-model="Mensagem" :placeholder="$t('contact.yourMessage')"></textarea>
                                        <button @click.prevent="EnviaEmail()" class="site-btn">{{ $t('contact.sendContact') }}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import { useHead } from '@vueuse/head';

export default {
  name: 'FaleConoscoView',
  components: {
  },
  data: () => ({
    contatotopo: [],
    contato: [],
    Nome: '',
    Email: '',
    Telefone: '',
    Assunto: '',
    Mensagem: '',
    redes:[],
  }),
  methods: {
    carregaMetas() {
			useHead({
				title: 'Fale Conosco - Sub4 Turismo'
			})
		},
    EnviaEmail() {
      if (this.Nome == '') {
        this.$mensagemAviso(this.$t('common.nameRequired'))
      }
      else if (this.Email == '') {
        this.$mensagemAviso(this.$t('common.emailRequired'))
      }
      else {
        let _dadosEmail = {
          nomeDe: this.Nome,
          nomePara: "Sub4 Turismo",
          assunto: 'Contato do Site Sub4 Turismo - ' + this.Nome,
          destinatario: this.contato[0].itiCampoExtra1,
          emailResposta: this.Email,
          textoEmail: "Nome: " + this.Nome + "<br>" + "E-mail: " + this.Email + "<br>Telefone: " + this.Telefone + "<br>Mensagem: " + this.Mensagem,
          nomeAnexo: '',
          anexo: '',
          tipoAnexo: ''
        }
        axios.post(`/Process/AdmControleSmtp/Enviamail`, _dadosEmail)
          .then(response => {
            if (response.data >= 1) {
              this.$mensagemSucesso(this.$t('common.emailSentSuccess'))
              this.Nome = "";
              this.Email = "";
              this.Telefone = "";
              this.Assunto = "";
              this.Mensagem = "";
            }
          });
      }
    },
  },
  created() {
    this.carregaMetas();

    axios.get('/Process/InsInstitucional/institucional/16/contato')
      .then(response => {
        this.contato = response.data;
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style>
.das {
  display: block !important;
}

.slider-text h2 p {
  font-size: 60px;
  color: #081624;
  padding: 10px;
  display: inline-block;
  background: #99CC33;
  line-height: 1;
}</style>
